import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './LicenseTransfer.messages';

const LicenseTransfer: FunctionComponent = () => {
  return (
    <>
      <h1>
        <FormattedMessage {...messages.title} />
      </h1>
    </>
  );
};

export default LicenseTransfer;
